import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Route, Switch, useLocation, useHistory } from 'react-router-dom';
import firebase from 'firebase'


import './App.sass';
import { DarkModeContext } from "./global/Theme";
import { AuthProvider } from './global/Auth'

import { AnimatedSwitch } from 'react-router-transition';



import { DesktopNav, MobileNav } from './components/common/Navbar'
import { authState, currentUserAuthState, getCurrentUser } from './api/auth'
import { routes } from './routes';


function App() {

	let location = useLocation();
	const history = useHistory()
	const routeComponents = routes.map(({path, component}, key) => <Route path={path} component={component} key={key} />);
	// const [bodyWidth, setBodyWidth] = useState(document.body.clientWidth);

	const [userData, setUserData] = useState({})
	let activeTheme = useSelector(state => state.activeTheme);
	let isDark = useSelector(state => state.isDark);
	let userId = useSelector(state => state.userState.id)
	let styles = {
		backgroundColor: activeTheme.bgColor
	}
	let messaging = null;
	var isLoggedIn = null

	// useEffect to watch for width height change
	const [bodyWidth, setBodyWidth] = useState(document.body.clientWidth);
    const updateWindowWidth = () => {
        // setBodyHeight(document.body.clientHeight);
        setBodyWidth(document.body.clientWidth);
	}
	
	useEffect(() => {
		window.addEventListener('resize', updateWindowWidth);
		if(document.body.clientWidth < 580){

			if(location.pathname == '/search' || location.pathname == '/notification' || location.pathname == '/settings' ){
				document.getElementById('mainWrapper').style.cssText = "padding: 70px 0 0 0 !important"	
			} else if(location.pathname == '/new-post'){
				document.getElementById('mainWrapper').style.cssText = "padding: 70px 0 70px 0 !important"
			} else if(location.pathname == '/wallet'){
				document.getElementById('mainWrapper').style.cssText = "padding: 70px 20px 0px 20px !important"
			} 
			else {
				document.getElementById('mainWrapper').style.cssText = "padding: 70px 10px 70px 10px !important"
				console.log('humne ki hai 70 padding')
				document.getElementById('desktopNav').style.display = 'flex'
			}
		} else if(document.body.clientWidth > 580) {
			console.log("setting main wrapper padding from app.js 100 0");
			if(location.pathname == '/home' || location.pathname == '/new-post'  || location.pathname.includes('/post') || location.pathname == '/settings' || location.pathname == '/editprofile' || location.pathname == '/settings' || location.pathname == '/profile'){
				document.getElementById('mainWrapper').style.cssText = "padding: 85px 0 0 0 !important"	
			} else if(location.pathname == '/about' || location.pathname == '/cookies' || location.pathname == '/terms' || location.pathname == '/help' || location.pathname == '/privacy' || location.pathname == '/copyright'){
				document.getElementById('mainWrapper').style.cssText = "padding: 0 0 0 0 !important"
			} else {
				document.getElementById('mainWrapper').style.cssText = "padding: 100px 0 0 0 !important"
			}
		}
	}, [bodyWidth]);



	// theme handlers
	const dispatch = useDispatch();
	const toggleDarkMode = () => {
		dispatch({ type: "TOGGLE_THEME" });
	}

	const sleep = async (ms) => {
		return new Promise(resolve => setTimeout(resolve, ms))
	}

	useEffect(() => {
		authState(observer => {
			if (observer == null) {
				localStorage.removeItem('persist:root');
				history.push('/login')
			}else{
			   // console.log(observer)
				getCurrentUser(observer.uid, (user) => {
					dispatch({
						type: 'UPDATE_USER_DATA', payload: user.data()
					})
					setUserData(user.data());
				})
			}
		})
		if (firebase.messaging.isSupported()) {
			messaging = firebase.messaging()
			messaging.onMessage(async on => {
				console.log(on)
				if (on.notification.body.toLowerCase().includes('liked') || on.notification.title.toLowerCase().includes('liked')) {
					dispatch({
						type: 'SET_NOTIFICATION', payload: {
							isEnabled: true,
							text: `@${on.notification.title} ${on.notification.body}`,
							icon: 'notifheart.svg'
						}
					})
					await sleep(3000)
					dispatch({
						type: 'SET_NOTIFICATION', payload: {
							isEnabled: false,
							text: '',
							icon: ''
						}
					})
				} else if (on.notification.body.toLowerCase().includes('commented') || on.notification.title.toLowerCase().includes('commented')) {
					dispatch({
						type: 'SET_NOTIFICATION', payload: {
							isEnabled: true,
							text: `@${on.notification.title}`,
							icon: 'notifcomment.svg'
						}
					})
					await sleep(3000)
					dispatch({
						type: 'SET_NOTIFICATION', payload: {
							isEnabled: false,
							text: '',
							icon: ''
						}
					})
				} else if (on.notification.body.toLowerCase().includes('messaged') || on.notification.title.toLowerCase().includes('messaged')) {
					dispatch({
						type: 'SET_NOTIFICATION', payload: {
							isEnabled: true,
							text: `@${on.notification.title}`,
							icon: 'notifcomment.svg'
						}
					})
					await sleep(3000)
					dispatch({
						type: 'SET_NOTIFICATION', payload: {
							isEnabled: false,
							text: '',
							icon: ''
						}
					})
				}
			})
		} else {
			console.log('front notifications not supported')

		}
	}, [])




	useEffect(() => {
		if (isDark) {
			document.getElementById('body').style.background = "#212426";
			document.getElementById('body').classList.add('darkScrollbar');
			document.getElementById('body').classList.remove('lightScrollbar');
		} else {
			document.getElementById('body').style.background = "#e6e8eb";
			document.getElementById('body').classList.add('lightScrollbar');
			document.getElementById('body').classList.remove('darkScrollbar');
		}

	}, [isDark])



	const handleInit = async () => {
		await sleep(500);
		try {
			isLoggedIn = JSON.parse(localStorage.getItem('persist:root')).isLoggedIn;
		} catch (e) {
			console.log(e)
		}

		try {
			await sleep(1000);
			console.log(window.location.href)

			const mode = window.location.href.split('?mode=')[1].split('&oobCode')[0]
			const code = window.location.href.split('&oobCode=')[1].split('&apiKey')[0]
			console.log(window.location.href)
			if (mode == 'resetPassword') {
				console.log("HEEEEEEEE")
				history.push({
					pathname: `/new-password/${code}`,
					state: { code: code }
				})
				window.location.reload();
			}
			else {


				if (isLoggedIn == 'false') {
					history.push('/login')
					document.getElementById('desktopWrapper').style.display = 'none';
					document.getElementById('mobileWrapper').style.display = 'none';
				} else {
					history.push(location.pathname)
				
					if (location.pathname == '/') {
						document.getElementById('desktopWrapper').style.display = 'flex';
						document.getElementById('mobileWrapper').style.display = 'flex';
						history.push('/home')
						dispatch({
							type: 'UPDATE_NAV', payload: {
								notification: false,
								home: true,
								search: false,
								post: false,
								chat: false,
								profile: false
							}
						})
					}
				}
			}
		} catch (e) {
			console.log(e);
			if (isLoggedIn == 'false') {
				history.push('/login')
				document.getElementById('desktopWrapper').style.display = 'none';
				document.getElementById('mobileWrapper').style.display = 'none';
			} else {
				history.push(location.pathname)
				
				if (location.pathname == '/') {
					document.getElementById('desktopWrapper').style.display = 'flex';
				document.getElementById('mobileWrapper').style.display = 'flex';
					history.push('/home')
					dispatch({
						type: 'UPDATE_NAV', payload: {
							notification: false,
							home: true,
							search: false,
							post: false,
							chat: false,
							profile: false
						}
					})
				}
			}
		}
	}

	useEffect(() => {
		handleInit();
	}, [])


	useEffect(() => {
		if (userId) {
			if (isLoggedIn) {
				getCurrentUser(userId, (user) => {
					dispatch({
						type: 'UPDATE_USER_DATA', payload: user.data()
					})
					setUserData(user.data());
				})
			}
		}
	}, [userId])

	useEffect(() => {
		styles = {
			backgroundColor: activeTheme.bgColor
		}
	}, [activeTheme, styles, isDark, location.pathname])

	useEffect(()=>{
		if(userId){
		var uid = userId
		var userStatusDatabaseRef = firebase.database().ref('/status/' + uid);
		var isOfflineForDatabase = {
			state: 'offline',
			last_changed: firebase.database.ServerValue.TIMESTAMP,
		};
		var isOnlineForDatabase = {
			state: 'online',
			last_changed: firebase.database.ServerValue.TIMESTAMP,
		};

		firebase.database().ref('.info/connected').on('value', function(snapshot) {
			// If we're not currently connected, don't do anything.
			if (snapshot.val() == false) {
				return;
			};
		
			// If we are currently connected, then use the 'onDisconnect()' 
			// method to add a set which will only trigger once this 
			// client has disconnected by closing the app, 
			// losing internet, or any other means.
			userStatusDatabaseRef.onDisconnect().set(isOfflineForDatabase).then(function() {
				// The promise returned from .onDisconnect().set() will
				// resolve as soon as the server acknowledges the onDisconnect() 
				// request, NOT once we've actually disconnected:
				// https://firebase.google.com/docs/reference/js/firebase.database.OnDisconnect
		
				// We can now safely set ourselves as 'online' knowing that the
				// server will mark us as offline once we lose connection.
				userStatusDatabaseRef.set(isOnlineForDatabase);
			});
		});
	}
	}, [userId])



	return (
		<DarkModeContext.Provider value={{ activeTheme, isDark, toggleDarkMode }}>
			<AuthProvider.Provider value={{ userData }}>
				<div className="App" style={styles} >
					{/* {loaded == false && <div className="splash">
						<img src={require('./assets/img/splash.svg')} />
					</div>} */}

					<DesktopNav />
					<MobileNav />
					<div id="mainWrapper">
						{/* {cropModal && <EditProfilePic />} */}
						<Switch
						// atEnter={{ offset: -1000 }}
						// atLeave={{ offset: 1000 }}
						// atActive={{ offset: 0 }}
						// mapStyles={(styles) => ({
						// 	transform: `translateX(${styles.offset}%)`,
						//})}
						>
							{routeComponents}
							
						</Switch>
					</div>

				</div>
			</AuthProvider.Provider>
		</DarkModeContext.Provider>
	);
}

export default App;
